module.exports = __webpack_public_path__ + "static/media/칸타타프리미엄라떼175ml_2.4afa8434.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/snacks/칸타타프리미엄라떼175ml_2.png
// module id = 501
// module chunks = 0